import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CurrencySettingsService {
  public currencySymbol: string = 'AED';
  public conversionRate: number = 1;
  public baseCurrencySymbol: string = 'AED';

  setCurrency(symbol: string, rate: number): void {
    this.currencySymbol = symbol;
    this.conversionRate = rate;
  }
}
